import React from 'react';
import styled from '@emotion/styled';
import { css as jsstyle } from '@emotion/react';
// --- external imports -----

import Asset from '~/containers/GameAsset/BaseAssets';
// --- internal imports -----

function ProgressBar(props) {
    const {
        x,
        y,
        formatText,
        isRelativePositioned,
        scale,
        progressBarContainerProps,
        currentValue,
        maximumValue,
        backgroundProjection,
        shouldShowTextProgress,
    } = props;
    const progress = (100 * currentValue) / maximumValue;
    return (
        <ProgressBarBackground
            x={x}
            y={y}
            fontSize={1}
            scale={scale}
            projection={backgroundProjection}
            isRelativePositioned={isRelativePositioned}
        >
            <ProgressBarContainer
                fontSize={1}
                borderRadius={progressBarContainerProps.borderRadius ?? 0}
                left={progressBarContainerProps.innerLeft ?? 0}
                top={progressBarContainerProps.innerTop ?? 0}
                right={progressBarContainerProps.innerRight ?? 0}
                bottom={progressBarContainerProps.innerBottom ?? 0}
            >
                <ProgressBarInner 
                    borderRadius={progressBarContainerProps.borderRadius ?? 0}
                    progress={progress}
                />

                <ProgressBarText
                    isShown={shouldShowTextProgress}
                    currentValue={currentValue}
                    maximumValue={maximumValue}
                    formatText={formatText}
                />
            </ProgressBarContainer>
        </ProgressBarBackground>
    );
}

function ProgressBarText(props) {
    const { isShown, formatText, currentValue, maximumValue } = props;

    if (!isShown) {
        return null;
    }

    return (
        <ProgressBarTextStyled fontSize={25.4}>
            {formatText(currentValue)} / {formatText(maximumValue)}
        </ProgressBarTextStyled>
    );
}

// If not isRelativePositioned, uses null so it reverts to the Asset x,y system
const getPositionInEm = ({ x, y, fontSize, isRelativePositioned }) =>
    isRelativePositioned
        ? jsstyle`
			left: ${x / fontSize}em;
			top: ${y / fontSize}em;
		`
        : null;

const ProgressBarBackground = styled(Asset.Backdrop)`
    ${getPositionInEm}
    pointer-events: none;
`;

const ProgressBarContainer = styled(Asset.Backdrop)`
    overflow: hidden;
    left: ${({ left }) => left}%;
    top: ${({ top }) => top}%;
    right: ${({ right }) => right}%;
    bottom: ${({ bottom }) => bottom}%;
    border-radius: ${({ borderRadius }) => borderRadius}em;
    pointer-events: none;
`;

const ProgressBarInner = styled.div`
    width: ${({ progress }) => progress}%;
    height: 100%;
    background: #feba17;
    background: linear-gradient(180deg, #feba17 0%, #b1810f 100%);
    border-radius: ${({ borderRadius }) => 0.9 * borderRadius}em;
`;

const ProgressBarTextStyled = styled(Asset.TextContainer)`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    top: 50%;
    transform: translate(0, -50%);
    font-family: 'LuckiestGuy';
    color: #fff4db;
    overflow: visible;
`;

export default ProgressBar;
